import * as requestFromServer from "./ActivityTypesCrud";
import { callTypes, activityTypeSlice } from "./ActivityTypesSlice";

const {actions} = activityTypeSlice;

export const getActivityTypes = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getActivityTypes(queryParams)
    .then(response => {
      dispatch(actions.activityTypesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllActivityTypes = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllActivityTypes(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getActivityType = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  if (!id) {
    return requestFromServer
    .getNewActivityType()
    .then(response => {
      dispatch(actions.activityTypeFetched(response.data));
    })
    .catch(error => {
      
    });
  }

  return requestFromServer
    .getActivityType(id)
    .then(response => {
      dispatch(actions.activityTypeFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveActivityType = personnelType => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveActivityType(personnelType)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteActivityTypes = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteActivityTypes(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanActivityTypesState = () => dispatch => {
  dispatch(actions.activityTypesStateCleaned());
}